import React from 'react';
import { TFormVariant } from '../../../../../form/Form.types';
import { InputSkeletonProps } from '../../input-skeleton';
import { useSkeletonContext } from '../../input-skeleton.context';
import ClearIcon from './components/clear-icon';
import { RightWrapper } from './input-clear-action.styled';

interface InputClearAction {
  onClearPress?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  variant?: TFormVariant;
  right?: InputSkeletonProps['right'];
  clearable?: boolean;
}

const InputClearAction: React.FunctionComponent<InputClearAction> = ({
  onClearPress,
  variant,
  right,
  clearable = true,
}) => {
  const { disabled, readonly } = useSkeletonContext();
  const finalDisabled = disabled || readonly;

  return (
    <RightWrapper>
      <>
        <ClearIcon
          style={clearable ? undefined : { visibility: 'hidden', pointerEvents: 'none' }}
          disabled={finalDisabled}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClearPress?.(e);
          }}
          variant={variant}
          hasSibling={clearable && !!right}
        />
        {right}
      </>
    </RightWrapper>
  );
};

export default InputClearAction;
